var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:_vm.buttonClass,attrs:{"data-sense":"sense_loan_online_widget","onclick":"SENSE.loanMe()"}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }